import { EDIT_TAGS_REQUEST_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const fetchTags = (reportId, reportType, reportState) => ({
  type: TAGS_REQUEST_ASYNC.INITIATE,
  payload: { reportId, reportType, reportState },
})
export const fetchTagsSuccess = (data, reportId, reportType) => ({
  type: TAGS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId, reportType },
})
export const fetchTagsError = (error, reportId, reportType) => ({
  type: TAGS_REQUEST_ASYNC.ERROR,
  error,
  payload: { reportId, reportType },
})

const editTags = (reportId, reportType, type, tagsArr) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.INITIATE,
  payload: {
    reportId,
    reportType,
    type,
    tagsArr,
  },
})
export const editTagsSuccess = (data, reportId, reportType) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.SUCCESS,
  payload: { data, reportId, reportType },
})
export const editTagsError = (error, reportId, reportType) => ({
  type: EDIT_TAGS_REQUEST_ASYNC.ERROR,
  error,
  payload: { reportId, reportType },
})

export default {
  // to props
  fetchTags,
  editTags,
}
